module.exports = __webpack_public_path__ + "static/media/guinness-storehouse.edb82d2b.png";